import { baseCard, chipBaseStyle } from 'styles/components/Common';

// Helper for chip styles
export const createChipStyle = (
  backgroundColor: string,
  color: string,
  border: string
) =>
  ({
    ...chipBaseStyle,
    backgroundColor,
    color,
    border
  }) as const;

// Helper for bordered card styles
export const createBorderedCard = (
  backgroundColor: string,
  borderColor: string
) =>
  ({
    ...baseCard,
    backgroundColor,
    border: `1px solid ${borderColor}`
  }) as const;
